import {Skeleton} from 'antd';
import React, {memo} from 'react';

const FormSkeleton = () => {
  return (
    <>
      <Skeleton/>
      <Skeleton/>
      <Skeleton/>
    </>
  );
};

export default memo(FormSkeleton);
